var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,4.8H18V1.2C18,0.5,17.5,0,16.8,0H7.2C6.5,0,6,0.5,6,1.2v3.6H1.2C0.5,4.8,0,5.3,0,6c0,0,0,0,0,0v9.6 c0,0.7,0.5,1.2,1.2,1.2v6c0,0.7,0.5,1.2,1.2,1.2h19.2c0.7,0,1.2-0.5,1.2-1.2v-6c0.7,0,1.2-0.5,1.2-1.2V6C24,5.3,23.5,4.8,22.8,4.8z  M8.4,2.4h7.2v2.4H8.4V2.4z M20.4,21.6H3.6v-4.8h4.8V18c0,0.7,0.5,1.2,1.2,1.2h4.8c0.7,0,1.2-0.5,1.2-1.2v-1.2h4.8V21.6z M10.8,16.8 v-2.4h2.4v2.4H10.8z M21.6,14.4h-6v-1.2c0-0.7-0.5-1.2-1.2-1.2H9.6c-0.7,0-1.2,0.5-1.2,1.2v1.2h-6V7.2h19.2V14.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.1aa651f4d87502f9029dd8bfdb66ddaa.svg";
export { ForwardRef as ReactComponent };